// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cheapest-deliveries-list{padding:0;margin:0;list-style:none;padding:12px 16px}.cheapest-deliveries-list__item{font-size:14px;line-height:24px;margin:0}.cheapest-deliveries-list__item:not(:first-child){margin-top:4px}.cheapest-deliveries-list._mobile .cheapest-deliveries-list__item{font-size:16px;line-height:24px;display:flex;justify-content:space-between}.cheapest-deliveries-list._mobile .cheapest-deliveries-list__item:not(:first-child){margin-top:8px}", ""]);
// Exports
module.exports = exports;
